import sanitizeHtml from 'sanitize-html';

// Rich text written in CKEditor (tickets, comments, chat, blog, knowledge base) comes from users,
// including anonymous visitors, so it is cleaned before any v-html: no scripts, event handlers,
// iframes or javascript: links. Images and basic formatting are kept.
const options = {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img', 'figure', 'figcaption', 'h1', 'h2', 'u', 's', 'span']),
    allowedAttributes: {
        ...sanitizeHtml.defaults.allowedAttributes,
        img: ['src', 'alt', 'width', 'height'],
        '*': ['class'],
    },
    allowedSchemesByTag: {
        img: ['http', 'https', 'data'],
    },
};

export default function safeHtml(html) {
    return sanitizeHtml(html || '', options);
}
